import { render, staticRenderFns } from "./TabAttachments.vue?vue&type=template&id=aa2863c4&scoped=true&"
import script from "./TabAttachments.vue?vue&type=script&lang=js&"
export * from "./TabAttachments.vue?vue&type=script&lang=js&"
import style0 from "./TabAttachments.vue?vue&type=style&index=0&id=aa2863c4&scoped=true&lang=scss&"
import style1 from "./TabAttachments.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa2863c4",
  null
  
)

export default component.exports